import {
  NewBuy2,
  PriceView,
  Quantity,
  StarRating,
  Table,
} from "@/Components/Index";
import type { ProductByIdPdp } from "@/Models/MPDP/ProductByIdPDP";
import useWindowsSize from "@/Hooks/useWindowsSize";
import type React from "react";

type Props = {
  mDatos: ProductByIdPdp[];
  onClicksQunatity: (value: number) => void;
  onClickBuy: () => void;
  isLoadingActiveButton: boolean;
};

export const ProductDetailView: React.FC<Props> = ({
  mDatos,
  onClicksQunatity,
  onClickBuy,
  isLoadingActiveButton,
}: Props) => {
  const { width } = useWindowsSize();

  return (
    <div className="ps-product__info">
      <h1 className="text-style ellipsis-product-name">
        {mDatos[0]?.NameArticle}
      </h1>
      <div className="d-flex flex-column mb-1">
        <div
          className={
            mDatos[0]?.CratesAndReviews && mDatos[0]?.CBvAverageRating > 0
              ? "p-0"
              : "p-3"
          }>
          {mDatos[0]?.CratesAndReviews && mDatos[0]?.CBvAverageRating > 0 ? (
            <StarRating
              rating={Math.floor(mDatos[0]?.CBvAverageRating)}
              totales={mDatos[0]?.CBvRatingRange}
              fontStar={16}
              fontNumber={16}
            />
          ) : (
            <span></span>
          )}
        </div>
        <div className="p-2 d-flex flex-column mx-0">
          <PriceView
            salesPrice={mDatos[0]?.SalesPrice ?? ""}
            listPrice={mDatos[0]?.ListPrice ?? ""}
          />
        </div>
      </div>
      <div className="ps-product__shopping">
        <figure>
          <figcaption>Cantidad</figcaption>
          <Quantity clickQuantity={onClicksQunatity} />
        </figure>
        {width >= 1200 ? (
          <NewBuy2
            title={"Comprar Ahora"}
            toStatus={isLoadingActiveButton}
            movilWeb={true}
            onClicks={onClickBuy}
            isLoadingClickBtn={isLoadingActiveButton}
          />
        ) : (
          ""
        )}
      </div>
      <div className="ps-product__content ps-tab-root">
        <Table
          longDescription={mDatos[0]?.LongDescription ?? ""}
          cTab2Content={mDatos[0]?.CTab2Content ?? ""}
        />
        <br />
      </div>
    </div>
  );
};
